export const knownErrorMessages = {
  'authorization failure': 'auth failure',
  'user already exists': 'already exists',
  'phone/email already in use': 'already in use',
  'invalid password': 'invalid password',
  'invalid phone': 'invalid phone',
  'promo code is not active': 'The supplied promo code is not active at this time',
};
